import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutUsSection from '../components/ProsSection';
import ServicesSection from '../components/ServicesSection';
import LawyersSection from '../components/LawyersSection';

const Home = () => {
  return (
    <div>
      <HeroSection />
      <AboutUsSection />
      <div id="services"><ServicesSection /></div>
      <LawyersSection />
    </div>
  );
};

export default Home;